import { getCachedCmsAccessToken } from 'shared/api/cms-auth';
/** Strip wrapping quotes webpack or copy/paste sometimes adds. */
export const normalizeBearerToken = (value) => {
    if (value == null) {
        return '';
    }
    return String(value).trim().replace(/^"|"$/g, '');
};
/** Resolve CMS Bearer token: runtime getter → cached fetch → window hook. */
export const resolveCmsAccessToken = (runtimeGetter) => {
    const candidates = [
        runtimeGetter?.(),
        getCachedCmsAccessToken(),
        typeof window !== 'undefined' ? window.__CMS_MFE_GET_ACCESS_TOKEN__?.() : null,
    ];
    for (const candidate of candidates) {
        const token = normalizeBearerToken(candidate);
        if (token) {
            return token;
        }
    }
    return '';
};
export const setAxiosAuthorizationHeader = (config, token) => {
    const value = `Bearer ${normalizeBearerToken(token)}`;
    const headers = config.headers;
    if (headers && typeof headers.set === 'function') {
        headers.set('Authorization', value);
        return;
    }
    headers.Authorization = value;
};
